import React from "react";
import { CheckCircle2 } from "lucide-react";

export const About = () => {
  const expertise = [
    "Operational Rigor",
    "Systems Thinking",
    "Commercial Acumen",
    "Source-to-Contract Excellence",
    "Process Optimization",
    "Organisational Performance",
  ];

  return (
    <section
      id="about"
      className="py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-slate-50 to-white"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Image/Visual */}
          <div className="relative">
            <div className="aspect-square bg-gradient-to-br from-blue-50 to-slate-100 rounded-2xl flex items-center justify-center">
              <div className="text-center p-12">
                <div className="w-32 h-32 bg-[#1e3a8a] rounded-full flex items-center justify-center mx-auto mb-6">
                  <span className="text-5xl font-bold text-white">LT</span>
                </div>
                <h3 className="text-3xl font-bold text-gray-900 mb-2">
                  Ludvik Thorsteinsson
                </h3>
                <p className="text-lg text-gray-600">
                  Founder & Principal Consultant
                </p>
              </div>
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-[#1e3a8a] rounded-2xl -z-10"></div>
          </div>

          {/* Right Column - Content */}
          <div>
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
              Expert Leadership,
              <br />
              <span className="text-[#1e3a8a]">Proven Results</span>
            </h2>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Ludvik is the Founder and Principal Consultant at L.T.I.
              Consulting, bringing a blend of operational rigor, systems
              thinking, and commercial acumen to procurement (source-to-contract),
              organisational performance and process optimisation.
            </p>

            {/* Expertise List */}
            <div className="space-y-4 mb-8">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">
                Core Expertise:
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {expertise.map((item) => (
                  <div key={item} className="flex items-center gap-3">
                    <CheckCircle2 className="w-5 h-5 text-[#1e3a8a] flex-shrink-0" />
                    <span className="text-gray-700">{item}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Call to action */}
            <div className="bg-blue-50 rounded-xl p-6 border-l-4 border-[#1e3a8a]">
              <p className="text-gray-700 italic">
                "I help SMEs unlock value in their procurement function through
                practical, results-driven strategies that are both simple to
                implement and inexpensive to execute."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};